export default __webpack_public_path__ + "static/media/corfo.f3dfd95a.png";